<script setup>
  import {inject, ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import ComponentInput from "@components/Inputs/Input.vue";
  import {useForm} from "@inertiajs/vue3";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentRecordEditLabelDialog",
  });

  // TODO - why the fuck do we use props.record and dont declare as prop?
  const props = defineProps({});

  const broadcast = inject("$broadcast");

  const refDialog = ref(null);

  const form = useForm({
    label: null,
  });

  const currentRecord = ref(props.record);

  function open(record) {
    if (record !== undefined) {
      currentRecord.value = record;
    }

    form.label = currentRecord.value.label;
    refDialog.value.open();
  }

  function close() {
    form.label = null;
    refDialog.value.close();
  }

  function save() {
    form.patch(route("records.update", {patient: currentRecord.value.patient_id, record: currentRecord.value.id}), {
      preserveScroll: true,
      headers: {
        // avoid updating the edited_at values when just changing the status
        "Mc-Silent-Update": true,
      },
      onSuccess: () => {
        // reload list of records
        broadcast.postMessage({action: "reload.records"});
        // reload specific record
        broadcast.record.postMessage(currentRecord.value.id, {action: "reload.record"});
        close();
      },
    });
  }

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog
    ref="refDialog"
    dialog-width="small"
    dialog-title="Interne Bezeichnung bearbeiten"
    :test-id="getTestId('record-label-edit')"
  >
    <template #content>
      <form :test-id="getTestId('record-label-edit-dialog-form')" @submit.prevent="save">
        <ComponentInput
          v-model="form.label"
          label="Interne Bezeichnung"
          maxlength="40"
          :hide-clear="true"
          helper-text="Die interne Bezeichnung hilft Ihnen dabei, sich bei mehreren Varianten zu orientieren."
          :validation="form.errors.label"
          autocomplete="off"
          :test-id="getTestId('record-label-edit-dialog-form-label')"
        />
      </form>
    </template>

    <template #actions>
      <MedButton
        variant="primary"
        :disabled="form.processing"
        :data-test="getTestId('record-label-edit-dialog-save-button')"
        @click="save()"
      >
        Speichern
      </MedButton>

      <MedButton :data-test="getTestId('record-label-edit-dialog-close-button')" @click="close()">Abbrechen</MedButton>
    </template>
  </ComponentDialog>
</template>
